// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type EingangsrechnungInfo } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useGetEingangsrechnung(): (
  rechnungId: string
) => Promise<EingangsrechnungInfo> {
  const getAPI = useGetApi();
  return useCallback(
    async (rechnungId) =>
      (await getAPI()).rechnungen.getEingangsrechnung({ rechnungId }),
    [getAPI]
  );
}
